import _taggedTemplateLiteral from "/builds/schumacherweb/devbridge/scp-web-client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";

function _templateObject5() {
  var data = _taggedTemplateLiteral(["\n  position: relative;\n  right: ", ";\n"]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n  display: block;\n  margin: 0 auto;\n  max-width: 100%;\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n  border-radius: 8px;\n  margin: 10px;\n  max-width: 1000px;\n  min-width: 300px;\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  /* 64vh is approximate. Cannot get 100% correct one due to Material UI inline styles */\n  max-height: 64vh;\n  overflow-x: hidden;\n  overflow-y: auto;\n  position: relative;\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  width: auto;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import React from 'react';
import styled from 'styled-components';
import { color } from '@scp/ui-shared/theme/variables';
import { Icon } from '@scp/ui-shared/theme/icons';
import { IconButton } from '@scp/ui-shared/components/buttons';
import { Modal } from '@scp/ui-shared/components/modals';
import { HeaderToolbar } from '@scp/ui-shared/components/layout/HeaderToolbar';
import { baselineToPx } from '@scp/ui-shared/theme/utils';
import { HIPAA_DOWNLOAD_WARNING_TEXT } from './constants';
import { withHipaaConfirm } from './withHipaaConfirm';
var TEXT = {
  DOWNLOAD_LABEL: 'Tap to download this image',
  CLOSE: 'Close the modal'
};
var StyledModal = styled(Modal)(_templateObject());
var Content = styled.div(_templateObject2());
var ImageWrapper = styled.div(_templateObject3());
var Image = styled.img(_templateObject4());
var DownloadButton = styled(IconButton).attrs({
  title: TEXT.DOWNLOAD_LABEL
})(_templateObject5(), baselineToPx(2));
export var FullImagePreviewModal = withHipaaConfirm({
  confirmText: HIPAA_DOWNLOAD_WARNING_TEXT
})(function (_ref) {
  var onClose = _ref.onClose,
      onDownload = _ref.onDownload,
      title = _ref.title,
      subtitle = _ref.subtitle,
      fileMeta = _ref.fileMeta,
      checkHipaa = _ref.checkHipaa;

  var downloadFile = function downloadFile() {
    return onDownload(fileMeta);
  };

  return React.createElement(StyledModal, {
    open: !!fileMeta,
    onRequestClose: onClose,
    noPadding: true
  }, React.createElement(HeaderToolbar, {
    title: title,
    subtitle: subtitle,
    primaryAction: React.createElement(IconButton, {
      onClick: onClose,
      title: TEXT.CLOSE
    }, React.createElement(Icon, {
      name: "close"
    })),
    secondaryAction: fileMeta && React.createElement(DownloadButton, {
      onClick: checkHipaa(downloadFile)
    }, React.createElement(Icon, {
      name: "file-download",
      color: color.icon
    }))
  }), React.createElement(Content, null, React.createElement(ImageWrapper, null, fileMeta && React.createElement(Image, {
    src: fileMeta.url,
    alt: fileMeta.name,
    title: fileMeta.name
  }))));
});